import styled from 'styled-components'

const FollowersPopupStyle = styled.div.attrs()`
	background-color: rgba(1, 1, 1, 0.6);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	overflow-y: scroll;
	z-index: 1000;
	opacity: 1;
	pointer-events: all;

	.popup-cont {
		background-color: var(--white);
		width: var(--sp80x);
		border-radius: 20px;
		padding: var(--sp5x);
		position: relative;

		.op-close {
			position: absolute;
			top: var(--sp5x);
			right: var(--sp5x);
			cursor: pointer;
			font-size: var(--sp2x);
		}

    .invite-block {
      margin-top: var(--sp4x);
      .ant-form-item {
        margin-bottom: 0;
        flex:1;
        margin-right: var(--sp2x);
      }
    }

    .follow-cont {
      height:var(--sp49x);
      overflow:auto;
      margin-top:var(--sp4x);
      padding-right: var(--sp2x);

      &::-webkit-scrollbar {
        width: 3px;
        display: block;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: var(--purple);
        border-radius: 10px;
      }

      .single-user {
        border-bottom:1px solid var(--lightGrey);
        padding-bottom: var(--sp2-5x);
        margin-top:var(--sp2x);

        .left {
          .imageCont {
            width:var(--sp5-5x);
            padding-top:var(--sp5-5x);
            border-radius: 8px;
            overflow: hidden;
          }

          .info {
            margin-left:var(--sp2x);
          }
        }
      }
    }
	}

  @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
    .popup-cont {
      width:calc(100% - var(--sp4x));
      padding:var(--sp2-5x);
      
      .op-close {
        top: var(--sp2x);
        right: var(--sp2x);
      } 

      .invite-block {
        margin-top: var(--sp2x);
      }
    }
  }
`

export default FollowersPopupStyle
